module.exports = __webpack_public_path__ + "media/images/mobile/abouts/10-52171a0c9f85309d742bc7b7599de04a.png";